// extracted by mini-css-extract-plugin
export var paginationContainer = "_80-0";